import { PatientId } from "../../messages";
import { API } from "../../API";
import React from "react";
import { AppCard, AppCardHeader, AppCardTitle } from "../Generic/AppCard";
import styled from "@emotion/styled";
import { iconColors } from "../Generic/AppIconColors";
import { WARNING_ICON } from "../../utils/svgs_new";
import { AppIcon } from "../Generic/AppIcon";
import { translate } from "../../translate";
import { STRINGS } from "../../strings";
import { useOutsourcingAgencyQuery } from "./useOutsourcingAgencyQuery";

interface Props {
  patientId: PatientId;
  onRequestOutsourcingAgencyData: API["getOutsourcingAgencyData"];
  context: "Visit" | "Patient";
}

export function OutsourcingAgencyBanner(props: Props) {
  const query = useOutsourcingAgencyQuery(props);

  if (query.isLoading || query.isError || query.data === null) {
    return null;
  }

  const agency = query.data;

  return (
    <StyledCard variant="soft" color="primary">
      <StyledAppCardHeader>
        <StyledAppCardTitle>
          <AppIcon icon={WARNING_ICON} fill={iconColors.get("primary")} size={16} />
          {translate(
            props.context === "Patient"
              ? STRINGS.THIS_PATIENT_BELONGS_TO_AGENCY
              : STRINGS.THIS_VISIT_IS_FOR_DIFFERENT_AGENCY
          ).replace("{{agencyName}}", agency.name)}
        </StyledAppCardTitle>
      </StyledAppCardHeader>
    </StyledCard>
  );
}

const StyledCard = styled(AppCard)`
  margin-bottom: 1rem;
`;

const StyledAppCardTitle = styled(AppCardTitle)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledAppCardHeader = styled(AppCardHeader)``;
